import { SearchReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';
const initialState: SearchReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};
const searchReducer = createReducer(initialState, {
  GET_SEARCH_DATA_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },
  GET_SEARCH_DATA_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },
  GET_SEARCH_DATA_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: action.payload.data.detail,
      done: false,
    };
  },
  CLEAR_SEARCH_DATA: (state) => {
    state.status = {
      loading: false,
      error: false,
      done: false,
    };
    state.data = null;
  },
});
export default searchReducer;
